import IDB from "middleware/idb";
import { CHAT_DATABASE, MESSAGE_TABLE } from "config/keys";

const MessageIDB = new IDB(CHAT_DATABASE, MESSAGE_TABLE);

export default MessageIDB;
